_PROXY_ = ''//'/api'
//_APIURL_ = 'http://localhost:7800/api/'
// _IMGURL_ = 'http://localhost:9001/'

// _APIURL_ = 'https://devapi.itmprime.io/api/'
// _IMGURL_ = 'https://devimg.itmprime.io'

_APIURL_ = 'https://api.itmprime.io/api/'
_IMGURL_ = 'https://img.itmprime.io'
// _APIURL_ = '/api/'
//_APIURL_ = 'http://localhost:7800/api/'

//默认头像地址
_defaultimg_="/static/img/header.4210783b.png"
//当前App的版本
_AppVersion_="1.1.7"

//是不是web，如果是web则不需要监测下载
_IsWeb_=1
//打包后的地址

//  _defaultimg_="https://img.trademepro.com/uploads/header.png"

// _downloadA_="https://www.trademepro.com/pay.apk"
_ACCOUNTTYPY_=1//代表是承受商系统
_ORDERSTATUS_ = [
	{
		label:'待付款',
		value:1
	},
	{
		label:'待确认',
		value:2
	},
	{
		label:'已完成',
		value:3
	},
	{
		label:'已关闭',
		value:4
	},
	{
		label:'有异议',
		value:5
	},
	{
		label:'退返中',
		value:6
	}
]
